const card = 'bg-[#0d1529] border border-[#1e3a5f] rounded-xl p-5'
const sectionTitle = 'text-[11px] font-bold tracking-widest uppercase text-[#64748b] mb-4 flex items-center gap-2 before:content-["•"] before:text-[#38bdf8] before:text-base'

interface EaFile {
  platform: 'MT5' | 'MT4'
  label: string
  filename: string
  href: string
  size: string
  role: string
  installPath: string
  accent: string
  bgBadge: string
  textBadge: string
  borderColor: string
  hoverBg: string
}

const EA_FILES: EaFile[] = [
  {
    platform: 'MT5',
    label: 'TradeAssist MT5',
    filename: 'TradeAssist_MT5.ex5',
    href: '/downloads/TradeAssist_MT5.ex5',
    size: '49 KB',
    role: 'EA PROP — MetaTrader 5',
    installPath: 'MQL5/Experts/',
    accent: '#38bdf8',
    bgBadge: '#1e3a5f',
    textBadge: '#38bdf8',
    borderColor: '#38bdf8',
    hoverBg: '#1e3a5f',
  },
  {
    platform: 'MT4',
    label: 'iXen Bridge MT4',
    filename: 'iXen_Bridge_MT4.ex4',
    href: '/downloads/iXen_Bridge_MT4.ex4',
    size: '65 KB',
    role: 'EA BROKER — MetaTrader 4',
    installPath: 'MQL4/Experts/',
    accent: '#818cf8',
    bgBadge: '#1e1e3f',
    textBadge: '#818cf8',
    borderColor: '#818cf8',
    hoverBg: '#1e1e3f',
  },
]

export const EaDownloads = () => {
  return (
    <div className="p-6 min-h-screen" style={{ background: '#0a0f1e', color: '#e2e8f0' }}>

      <div className="mb-6">
        <h1 className="text-2xl font-black tracking-tight text-white">
          ↓ <span className="text-[#38bdf8]">Download</span> Expert Advisor
        </h1>
        <p className="text-[12px] text-[#475569] mt-1">
          Scarica gli EA compilati per MetaTrader 5 (PROP) e MetaTrader 4 (BROKER)
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl">
        {EA_FILES.map((ea) => (
          <div
            key={ea.platform}
            className="bg-[#0d1529] border border-[#1e3a5f] rounded-xl overflow-hidden"
            style={{ borderLeft: `3px solid ${ea.borderColor}` }}
          >
            <div className="p-5 flex flex-col gap-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <span
                      className="text-[10px] font-black px-2 py-0.5 rounded-full tracking-widest"
                      style={{ background: ea.bgBadge, color: ea.textBadge }}
                    >
                      {ea.platform}
                    </span>
                    <span className="text-[10px] bg-green-900/40 text-green-400 px-2 py-0.5 rounded-full font-bold">
                      v2.1
                    </span>
                  </div>
                  <p className="text-base font-black text-white tracking-tight">{ea.label}</p>
                  <p className="text-[11px] text-[#64748b] mt-0.5">{ea.role} · {ea.size}</p>
                </div>
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center text-lg flex-shrink-0"
                  style={{ background: ea.bgBadge }}
                >
                  {ea.platform === 'MT5' ? '📈' : '📉'}
                </div>
              </div>

              <div className="bg-[#0a0f1e] rounded-lg p-3 border border-[#1e3a5f]/50">
                <p className="text-[10px] text-[#64748b] font-bold uppercase tracking-wider mb-1">Istruzioni installazione</p>
                <ol className="text-[11px] text-[#94a3b8] space-y-1 list-decimal list-inside">
                  <li>Scarica il file <span className="font-mono text-[#cbd5e1]">{ea.filename}</span></li>
                  <li>
                    Copia in{' '}
                    <span className="font-mono" style={{ color: ea.accent }}>
                      {ea.installPath}
                    </span>
                    {' '}del tuo terminale
                  </li>
                  <li>Riavvia il terminale o aggiorna la lista EA nel Navigator</li>
                  <li>Trascina l'EA sul grafico e inserisci il token dalla pagina iXen System</li>
                </ol>
              </div>

              <a
                href={ea.href}
                download={ea.filename}
                className="flex items-center justify-center gap-2 font-bold text-sm px-4 py-3 rounded-lg transition-all border"
                style={{
                  borderColor: `${ea.accent}40`,
                  color: ea.accent,
                  background: `${ea.hoverBg}60`,
                }}
                onMouseEnter={e => (e.currentTarget.style.background = ea.hoverBg)}
                onMouseLeave={e => (e.currentTarget.style.background = `${ea.hoverBg}60`)}
              >
                ↓ Scarica {ea.filename}
              </a>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 max-w-3xl">
        <div className={`${card} flex items-start gap-3`}>
          <span className="text-yellow-400 text-lg flex-shrink-0 mt-0.5">⚠</span>
          <div>
            <p className="text-[12px] font-bold text-[#94a3b8] mb-1">Aggiornamenti EA</p>
            <p className="text-[11px] text-[#475569] leading-relaxed">
              Quando viene rilasciata una nuova versione degli EA, il numero di versione in questa pagina viene aggiornato.
              Ricarica la pagina per verificare se è disponibile un aggiornamento, poi ripeti il download e la compilazione.
              Le coppie già configurate non perdono i parametri — solo l'EA compilato viene sostituito.
            </p>
          </div>
        </div>
      </div>

    </div>
  )
}
